import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryKeys } from '../queries';
import Config from '../../config';
import { METHODS } from '../constants';
import { useMarkJimNotificationsAsSeen } from './jimJobs';

export type DownloadBatchReportExportFormat = 'xlsx' | 'csv';

export type DownloadBatchReportVariable = {
  jobId: string;
  exportFormat?: DownloadBatchReportExportFormat;
};

export const buildDownloadBatchReportUrl = (
  { jobId, exportFormat }: DownloadBatchReportVariable
) => Config.endpoints.DOWNLOAD_BATCH_REPORT.replace(':jobId', jobId)
  + (exportFormat ? `?format=${exportFormat}` : '');

export const useDownloadBatchReport = (onSuccess: OnSuccessCallback<Response, DownloadBatchReportVariable>) => {
  const { mutate: markJobNotificationAsSeen } = useMarkJimNotificationsAsSeen();

  return useCustomMutation<Response, Error, DownloadBatchReportVariable>({
    handleData: variable => ({
      url: buildDownloadBatchReportUrl(variable),
      method: METHODS.GET,
    }),
    invalidateKey: query => [QueryKeys.batchReports.DownloadBatchReport].includes(query.queryKey[0] as string),
    errorMessage: 'Generating file to download failed',
    successMessage: 'Generated report file successfully, wait for download',
    parseResponseErrorMessage: true,
    onSuccess,
    onMutate: ({ jobId }) => markJobNotificationAsSeen([jobId]),
  });
};

export type DownloadBatchZipReportVariable = {
  fileName: string;
};

export const useDownloadBatchZipReport = (onSuccess: OnSuccessCallback<Response, DownloadBatchZipReportVariable>) => {
  const { mutate: markJobNotificationAsSeen } = useMarkJimNotificationsAsSeen();

  return useCustomMutation<Response, Error, DownloadBatchZipReportVariable>({
    handleData: ({ fileName }) => ({
      url: Config.endpoints.DOWNLOAD_BATCH_ZIP_REPORT.replace(':fileName', fileName),
      method: METHODS.GET,
    }),
    invalidateKey: query => [QueryKeys.batchReports.DownloadBatchZipReport].includes(query.queryKey[0] as string),
    errorMessage: 'Generating file to download failed',
    successMessage: 'Generated report file successfully, wait for download',
    parseResponseErrorMessage: true,
    onSuccess,
    onMutate: ({ fileName }) => markJobNotificationAsSeen([fileName]),
  });
};
